<template>
  <div class="row">
    <div class="col-12">
      <h3 class="font-weight-bold mb-2">PRE-AGREEMENT</h3>
      <p>Please ensure that as much of the information below is filled out</p>
    </div>
    <div class="col-12">
      <ValidationObserver ref="editPreAgreementForm" slim>
        <form role="form" @submit.prevent="edit_pre_agreement_submit">
          <div class="row">

            <div class="col-12">
              <b-card header="Company Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- Incorporation Date -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Incorporation Date" tag="div">
                      <label class="form-label" for="incorporation_date">Incorporation Date</label>
                      <datepicker v-model="company_profile.incorporation_date" id="incorporation_date" name="incorporation_date" :input-class="['date-input', classes]"
                                  :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_incorporation_date" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Years Trading -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="First Name" tag="div">
                      <label class="form-label" for="years_trading">Years Trading</label>
                      <input type="text" v-model="pre_agreement.years_trading" id="years_trading" name="years_trading" class="form-input" :class="classes" maxlength="255">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Company UTR Number -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="digits:10" v-slot="{errors, classes}" name="UTR Number" tag="div">
                      <label class="form-label" for="utr_number">Company UTR Number</label>
                      <input type="text" v-model="company_profile.utr_number" id="utr_number" name="utr_number" class="form-input" :class="classes" maxlength="10">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- UTR Status -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="utr_status">UTR Status</label>
                    <multiselect v-model="company_profile.utr_status" id="utr_status" name="utr_status" placeholder="" :options="ms_opts.utr_status" label="value"></multiselect>
                  </div>
                  <!-- VAT Registration Number -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="VATregNoValidate|max:9" v-slot="{errors, classes}" name="VAT Number" tag="div">
                      <label class="form-label" for="vat_number">VAT Number</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">GB</span></div>
                        <input type="text" v-model="company_profile.vat_number" id="vat_number" name="vat_number" class="form-input" :class="classes" maxlength="9">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-xl-6"></div>
                  <!-- Companies House Turnover Last Submitted -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Turnover Amount" tag="div">
                      <label class="form-label" for="last_companies_house_turnover_submission">Last Companies House Submission Turnover Amount</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="pre_agreement.last_companies_house_turnover_submission" id="last_companies_house_turnover_submission"
                               name="last_companies_house_turnover_submission" class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Net Value on Balance Sheet -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Net Value on Balance Sheet" tag="div">
                      <label class="form-label" for="net_value_on_balance_sheet">Net Value on Balance Sheet</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="pre_agreement.net_value_on_balance_sheet" id="net_value_on_balance_sheet" name="net_value_on_balance_sheet" class="form-input"
                               :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Total Staffing numbers (inc. Contractors) -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Total Staffing numbers (inc. Contractors)" tag="div">
                      <label class="form-label" for="total_staffing_inc_contractors">Total Staffing numbers (inc. Contractors)</label>
                      <input type="text" v-model="pre_agreement.total_staffing_inc_contractors" id="total_staffing_inc_contractors" name="total_staffing_inc_contractors"
                             class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Currently qualify for accounts audit -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="qualify_for_accounts_audit">
                        Currently qualify for accounts audit
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.qualify_for_accounts_audit" id="qualify_for_accounts_audit" name="qualify_for_accounts_audit"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <b-card header="Current Staff/Contractor Information" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- PAYE staff engaged -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Number PAYE staff engaged" tag="div">
                      <label class="form-label" for="no_paye_staff_engaged">Number PAYE staff engaged</label>
                      <input type="text" v-model="pre_agreement.no_paye_staff_engaged" id="no_paye_staff_engaged" name="no_paye_staff_engaged" class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Labour only sub-contractors engaged -->
                  <div class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Number Labour only sub-contractors (CIS) engaged" tag="div">
                      <label class="form-label" for="no_labour_only_sub_contractors_engaged">Number Labour only sub-contractors (CIS) engaged</label>
                      <input type="text" v-model="pre_agreement.no_labour_only_sub_contractors_engaged" id="no_labour_only_sub_contractors_engaged"
                             name="no_labour_only_sub_contractors_engaged" class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <!-- Use a payroll company -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="use_a_payroll_company">Use a payroll company</label>
                      <div class="col-xl-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.use_a_payroll_company" id="use_a_payroll_company" name="use_a_payroll_company"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- (IF YES) - Payroll Company Name -->
                  <div v-if="pre_agreement.use_a_payroll_company" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Payroll Company Name" tag="div">
                      <label class="form-label" for="payroll_company_name">Payroll Company Name</label>
                      <input type="text" v-model="pre_agreement.payroll_company_name" id="payroll_company_name" name="payroll_company_name" class="form-input"
                             :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- (IF YES) - Payroll Company Charge type -->
                  <div v-if="pre_agreement.use_a_payroll_company" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Payroll Company Charge type" tag="div">
                      <label class="form-label" for="payroll_company_margin_type">Payroll Company Charge type</label>
                      <multiselect v-model="pre_agreement.payroll_company_margin_type" id="payroll_company_margin_type" name="payroll_company_margin_type" placeholder=""
                                   :options="ms_opts.payroll_company_margin_type" :class="classes" label="value"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- (IF YES) - Payroll Company Charge Amount -->
                  <div v-if="pre_agreement.use_a_payroll_company" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Payroll Company Charge Amount" tag="div">
                      <label class="form-label" for="payroll_company_margin_amount">Payroll Company Charge Amount</label>
                      <div class="input-group">
                        <div v-if="pre_agreement.payroll_company_margin_type === '£ (Pound)'" class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <div v-else-if="pre_agreement.payroll_company_margin_type === '% (Percentage)'" class="input-group-prepend"><span class="input-group-text">&percnt;</span>
                        </div>
                        <input type="text" v-model="pre_agreement.payroll_company_margin_amount" id="payroll_company_margin_amount" name="payroll_company_margin_amount"
                               class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- (IF YES) - Current Payroll terms of service stipulate they are offering -->
                  <div v-if="pre_agreement.use_a_payroll_company" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Current Payroll terms for service stipulate they are offering" tag="div">
                      <label class="form-label" for="current_payroll_company_tos_stipulate">Current Payroll terms for service stipulate they are offering</label>
                      <textarea type="text" v-model="pre_agreement.current_payroll_company_tos_stipulate" id="current_payroll_company_tos_stipulate"
                                name="current_payroll_company_tos_stipulate"
                                class="form-input" :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <!-- Utilise Limited Companies/PSCs -->
                  <div class="col-xl-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="utilise_ltd_pscs">
                        Utilise Limited Companies/Personal Service Companies (PSC's)
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.utilise_ltd_pscs" id="utilise_ltd_pscs" name="utilise_ltd_pscs" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Limited companies engaged -->
                  <div v-if="pre_agreement.utilise_ltd_pscs" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Number Limited companies engaged" tag="div">
                      <label class="form-label" for="no_limited_companies_engaged">Number Limited companies engaged</label>
                      <input type="text" v-model="pre_agreement.no_limited_companies_engaged" id="no_limited_companies_engaged" name="no_limited_companies_engaged"
                             class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- PSC's engaged -->
                  <div v-if="pre_agreement.utilise_ltd_pscs" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Number PSC's engaged" tag="div">
                      <label class="form-label" for="no_pscs_engaged">Number PSC's engaged</label>
                      <input type="text" v-model="pre_agreement.no_pscs_engaged" id="no_pscs_engaged" name="no_pscs_engaged" class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- SDC -->
                  <div v-if="pre_agreement.utilise_ltd_pscs" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}"
                                        name="Process to manage contracts & schedule of works, as well as Supervision, Control and Right of substitution" tag="div">
                      <label class="form-label" for="process_cw_scs">
                        Process to manage contracts & schedule of works, as well as Supervision, Control and Right of substitution
                      </label>
                      <textarea type="text" v-model="pre_agreement.process_cw_scs" id="process_cw_scs" name="process_cw_scs" class="form-input" :class="classes"
                                rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <!-- Recruitment Agencies -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="use_recruitment_agencies">Use Recruitment Agencies</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.use_recruitment_agencies" id="use_recruitment_agencies" name="use_recruitment_agencies"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Recruitment approx weekly numbers -->
                  <div v-if="pre_agreement.use_recruitment_agencies" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Recruitment approx weekly numbers" tag="div">
                      <label class="form-label" for="recruitment_approx_weekly_no">Recruitment approx weekly numbers</label>
                      <input type="text" v-model="pre_agreement.recruitment_approx_weekly_no" id="recruitment_approx_weekly_no" name="recruitment_approx_weekly_no"
                             class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Recruitment Payroll Companies -->
                  <div v-if="pre_agreement.use_recruitment_agencies" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}"
                                        name="Recruitment Payroll Companies and process they operate" tag="div">
                      <label class="form-label" for="recruitment_payroll_process">Recruitment Payroll Companies and process they operate</label>
                      <textarea type="text" v-model="pre_agreement.recruitment_payroll_process" id="recruitment_payroll_process" name="recruitment_payroll_process"
                                class="form-input" :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <b-card header="IR35 / Intermediaries / Right to Work / Outsourced Services" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- Ues Accountants -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="use_accountants">Do you currently use an accountants</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.use_accountants" id="use_accountants" name="use_accountants" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Accountant Company -->
                  <div v-if="pre_agreement.use_accountants" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Accountant Company Name" tag="div">
                      <label class="form-label" for="accountant_company">Accountant Company Name</label>
                      <input type="text" v-model="pre_agreement.accountant_company" id="accountant_company" name="accountant_company" class="form-input"
                             :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>

                  <!-- Accountant Company Contact -->
                  <div v-if="pre_agreement.use_accountants" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Accountant Contact Name" tag="div">
                      <label class="form-label" for="accountant_contact">Accountant Contact Name</label>
                      <input type="text" v-model="pre_agreement.accountant_contact" id="accountant_contact" name="accountant_contact" class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Accountant Company Contact Number -->
                  <div v-if="pre_agreement.use_accountants" class="col-xl-6 form-group">
                    <ValidationProvider rules="max:15" v-slot="{errors, classes}" name="Mobile" tag="div">
                      <label class="form-label" for="accountant_contact_number">Accountant Contact Number</label>
                      <input type="text" v-model="pre_agreement.accountant_contact_number" id="accountant_contact_number" name="accountant_contact_number" class="form-input"
                             :class="classes" maxlength="15">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Accountant Company contractor HR advice -->
                  <div v-if="pre_agreement.use_accountants" class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="accountant_company_contractor_hr">
                        Seek advice from accountant on contractor HR
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.accountant_company_contractor_hr" id="accountant_company_contractor_hr" name="accountant_company_contractor_hr"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <!-- Outsource your Employment Law/HR needs -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="outsource_employment_law_hr">
                        Do you outsource your Employment Law/HR needs
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.outsource_employment_law_hr" id="outsource_employment_law_hr" name="outsource_employment_law_hr"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Outsource Employment Law/HR yearly spend -->
                  <div v-if="pre_agreement.outsource_employment_law_hr" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Outsourced Employment Law/HR yearly spend" tag="div">
                      <label class="form-label" for="outsourced_employment_law_hr_spend">Outsourced Employment Law/HR yearly spend</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="pre_agreement.outsourced_employment_law_hr_spend" id="outsourced_employment_law_hr_spend"
                               name="outsourced_employment_law_hr_spend" class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <div class="col-12">
                    <h5>IR35 / INTERMEDIARIES / RIGHT TO WORK</h5>
                  </div>
                  <!-- IR35 / INTERMEDIARIES / RIGHT TO WORK advice received -->
                  <div class="col-12">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="ir35_advice_received">
                        IR35 / Intermediaries / Right to Work Advice received
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.ir35_advice_received" id="ir35_advice_received" name="ir35_advice_received" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- IR35 advice received from -->
                  <div v-if="pre_agreement.ir35_advice_received" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="IR35 advice received from" tag="div">
                      <label class="form-label" for="ir35_advice_received_from">IR35 advice received from</label>
                      <input type="text" v-model="pre_agreement.ir35_advice_received_from" id="ir35_advice_received_from" name="ir35_advice_received_from" class="form-input"
                             :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-xl-6"></div>
                  <!-- IR35 strategy -->
                  <div v-if="pre_agreement.ir35_advice_received" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="IR35 strategy" tag="div">
                      <label class="form-label" for="ir35_strategy">IR35 strategy</label>
                      <textarea type="text" v-model="pre_agreement.ir35_strategy" id="ir35_strategy" name="ir35_strategy" class="form-input" :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Intermediaries strategy -->
                  <div v-if="pre_agreement.ir35_advice_received" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Intermediaries strategy" tag="div">
                      <label class="form-label" for="intermediaries_strategy">Intermediaries strategy</label>
                      <textarea type="text" v-model="pre_agreement.intermediaries_strategy" id="intermediaries_strategy" name="intermediaries_strategy" class="form-input"
                                :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Right to work strategy -->
                  <div v-if="pre_agreement.ir35_advice_received" class="col-12 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Right to work strategy" tag="div">
                      <label class="form-label" for="r2w_strategy">Right to work strategy</label>
                      <textarea type="text" v-model="pre_agreement.r2w_strategy" id="r2w_strategy" name="r2w_strategy" class="form-input" :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-2 mb-4">
                  </div>
                  <!-- In relation to the above: have your services and contracts been reviewd in the last 6 months, re: Off-Payroll -->
                  <div class="col-12">
                    <div class="row">
                      <label class="col-md-9 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="off_payroll_6_month_review">
                        In relation to the above: have your services and contracts been reviewed in the last 6 months, re: Off-Payroll
                      </label>
                      <div class="col-md-3 form-group">
                        <bootstrap-toggle v-model="pre_agreement.off_payroll_6_month_review" id="off_payroll_6_month_review" name="off_payroll_6_month_review"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <div v-if="pre_agreement.off_payroll_6_month_review" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Off Payroll Review Date" tag="div">
                      <label class="form-label" for="off_payroll_last_review_date">Off Payroll Review Date</label>
                      <datepicker v-model="pre_agreement.off_payroll_last_review_date" id="off_payroll_last_review_date" name="off_payroll_last_review_date"
                                  :input-class="['date-input', classes]" :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times"
                                  @input="select_off_payroll_last_review_date_date" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <b-card header="Payment Information/Process" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- Signed up to CITB -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="signed_up_to_citb">Signed up to CITB</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.signed_up_to_citb" id="signed_up_to_citb" name="signed_up_to_citb" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Pass any CITB charge on to Contractors -->
                  <div v-if="pre_agreement.signed_up_to_citb" class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="citb_charge_onto_contractors">
                        Pass any CITB charge on to Contractors
                      </label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.citb_charge_onto_contractors" id="citb_charge_onto_contractors" name="signed_up_to_citb"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <div v-else class="col-xl-6"></div>
                  <div class="col-12">
                    <hr class="mt-0 mb-3">
                  </div>

                  <!-- Pay Frequency -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_cycle">Pay Frequency to Workers</label>
                    <multiselect v-model="payment_process_info.pay_cycle" id="pay_cycle" name="pay_cycle" placeholder="" :options="ms_opts.pay_cycle" label="value"></multiselect>
                  </div>
                  <div class="col-xl-6"></div>
                  <!-- Working week end day -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_week_start_day">Working week start day</label>
                    <multiselect v-model="payment_process_info.pay_week_start_day" id="pay_week_start_day" name="pay_week_start_day" placeholder=""
                                 :options="ms_opts.pay_week_start_day"></multiselect>
                  </div>
                  <!-- Client Instruction Day -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_instruction_day">Client Instruction Day</label>
                    <multiselect v-model="payment_process_info.pay_instruction_day" id="pay_instruction_day" name="pay_instruction_day" placeholder=""
                                 :options="ms_opts.pay_instruction_day"></multiselect>
                  </div>
                  <!-- Client Payment to Genius Day -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_client_payment_day">Client Payment to Genius Day</label>
                    <multiselect v-model="payment_process_info.pay_client_payment_day" id="pay_client_payment_day" name="pay_client_payment_day" placeholder=""
                                 :options="ms_opts.pay_client_payment_day"></multiselect>
                  </div>
                  <!-- Genius Payment to Worker Day -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_worker_payment_day">Genius Payment to Worker Day</label>
                    <multiselect v-model="payment_process_info.pay_worker_payment_day" id="pay_worker_payment_day" name="pay_worker_payment_day" placeholder=""
                                 :options="ms_opts.pay_worker_payment_day"></multiselect>
                  </div>
                  <!-- Genius Payment to Worker Time -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_worker_payment_time">Genius Payment to Worker Time</label>
                    <multiselect v-model="payment_process_info.pay_worker_payment_time" id="pay_worker_payment_time" name="pay_worker_payment_time" placeholder=""
                                 :options="ms_opts.pay_worker_payment_time"></multiselect>
                  </div>
                  <!-- Genius Text to Worker Day -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="pay_worker_text_day">Genius Text to Worker Day</label>
                    <multiselect v-model="payment_process_info.pay_worker_text_day" id="pay_worker_text_day" name="pay_worker_text_day" placeholder=""
                                 :options="ms_opts.pay_worker_text_day"></multiselect>
                  </div>
                  <div class="col-12">
                    <hr class="mt-0 mb-3">
                  </div>
                  <!-- Genius Charge Agreed -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="fee_margin_agreed">Fee/Margin Agreed</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="payment_process_info.fee_margin_agreed" id="fee_margin_agreed" name="fee_margin_agreed"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- Public Employers Insurance -->
                  <div v-if="payment_process_info.fee_margin_agreed" class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="payroll_pe_insurance">P.E. Insurance</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="payment_process_info.payroll_pe_insurance" id="payroll_pe_insurance" name="payroll_pe_insurance"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                      <div v-if="payment_process_info.payroll_pe_insurance" class="col-12">
                        <p class="pt-0 mb-3 text-right font-weight-bold">A Charge of {{ pe_ins | currency }} will be made on top of the agreed Admin Charge</p>
                      </div>
                    </div>
                  </div>
                  <!-- Genius Charge type -->
                  <div v-if="payment_process_info.fee_margin_agreed" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Admin Charge type" tag="div">
                      <label class="form-label" for="fee_margin_type">Admin Charge type</label>
                      <multiselect v-model="payment_process_info.fee_margin_type" id="fee_margin_type" name="fee_margin_type" placeholder=""
                                   :options="ms_opts.fee_type" :class="classes" label="value"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Genius Charge value -->
                  <div v-if="payment_process_info.fee_margin_agreed" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Genius Admin Charge Amount" tag="div">
                      <label class="form-label" for="fee_margin_amount">Genius Admin Charge Amount</label>
                      <div class="input-group">
                        <div v-if="payment_process_info.fee_margin_type === '£ (Pound)'" class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <div v-else-if="payment_process_info.fee_margin_type === '% (Percentage)'" class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="payment_process_info.fee_margin_amount" id="fee_margin_amount" name="fee_margin_amount" class="form-input"
                               :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div v-else class="col-xl-6"></div>
                  <!-- Require Payment Terms -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="payroll_require_payment_terms">Require Genius Payment
                        Terms</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="payment_process_info.payroll_require_payment_terms" id="payroll_require_payment_terms" name="payroll_require_payment_terms"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6"></div>
                  <!-- Payment - Days from Invoice -->
                  <div v-if="payment_process_info.payroll_require_payment_terms" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}"
                                        name="Payment Terms - Days from Invoice" tag="div">
                      <label class="form-label" for="payroll_payment_terms_length">Payment Terms - Days from Invoice</label>
                      <input type="text" v-model="payment_process_info.payroll_payment_terms_length" id="payroll_payment_terms_length" name="payroll_payment_terms_length"
                             class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Payment - Payment Terms Percentage Fee -->
                  <div v-if="payment_process_info.payroll_require_payment_terms" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}"
                                        name="Payment Terms Percentage Fee" tag="div">
                      <label class="form-label" for="payroll_payment_terms_value">Payment Terms Percentage Fee Amount</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="payment_process_info.payroll_payment_terms_value" id="payroll_payment_terms_value" name="payroll_payment_terms_value"
                               class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <div class="col-12">
                    <hr class="mt-0 mb-3">
                  </div>
                  <!-- Operate in the Domestic Environment -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="operate_domestic_env">Operate in the Domestic Environment</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="pre_agreement.operate_domestic_env" id="operate_domestic_env" name="operate_domestic_env" :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6"></div>
                  <!-- Genius Payroll Solution -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="payroll_solution">Genius Payroll Solution</label>
                    <multiselect v-model="payment_process_info.payroll_solution" id="payroll_solution" name="payroll_solution" placeholder=""
                                 :options="ms_opts.gm_solution" label="value" track-by="id"></multiselect>
                  </div>
                  <!-- VAT percentage worked to -->
                  <div class="col-xl-6 form-group">
                    <label class="form-label" for="min_vat_percentage_worked_to">Min VAT percentage worked to</label>

                    <multiselect v-model="payment_process_info.min_vat_percentage_worked_to" name="min_vat_percentage_worked_to" placeholder="" id="min_vat_percentage_worked_to"
                                 :options="ms_opts.vat_perc_worked_to" :readonly="disable_min_vat" label="value" track-by="id"></multiselect>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <b-card header="V3 Recruitment Partnership" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- Opt into V3 Partnership -->
                  <div class="col-xl-6">
                    <div class="row">
                      <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="recruitment_partnership">Opt into V3 Partnership</label>
                      <div class="col-md-4 form-group">
                        <bootstrap-toggle v-model="payment_process_info.recruitment_partnership" id="recruitment_partnership" name="recruitment_partnership"
                                          :options="{ on: 'Yes', off: 'No' }"/>
                      </div>
                    </div>
                  </div>
                  <!-- V3 Partnership margin type -->
                  <div v-if="payment_process_info.recruitment_partnership" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="V3 Partnership Margin Type" tag="div">
                      <label class="form-label" for="recruitment_partnership_fee_type">V3 Partnership Margin Type</label>
                      <multiselect v-model="payment_process_info.recruitment_partnership_fee_type" id="recruitment_partnership_fee_type" name="recruitment_partnership_fee_type"
                                   placeholder="" :options="ms_opts.v3_partnership_margin_type" :class="classes" label="value"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- V3 Partnership margin value -->
                  <div v-if="payment_process_info.recruitment_partnership" class="col-xl-6 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="V3 Partnership Margin Value" tag="div">
                      <label class="form-label" for="v3_partnership_margin_value">V3 Partnership Margin Value</label>
                      <div class="input-group">

                        <div v-if="payment_process_info.recruitment_partnership_fee_type !== null && payment_process_info.recruitment_partnership_fee_type.value === '£ (Pound)'"
                             class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <div
                            v-if="payment_process_info.recruitment_partnership_fee_type !== null && payment_process_info.recruitment_partnership_fee_type.value ===
                                        '% (Percentage)'" class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>

                        <input type="text" v-model="payment_process_info.recruitment_partnership_fee_value" id="v3_partnership_margin_value" name="v3_partnership_margin_value"
                               class="form-input" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-12">
              <b-card header="Client Rebate" header-tag="h4" body-class="mb-3 pb-0 record_card_body">
                <div class="row">
                  <!-- Rebate Amount per payrolled worker -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Rebate Amount per payrolled worker" tag="div">
                      <label class="form-label" for="edit_amount_per_payrolled_worker">Rebate Amount per payrolled worker</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&pound;</span></div>
                        <input type="text" v-model="referral_rebate.rebate.amount_per_payrolled_worker" id="edit_amount_per_payrolled_worker"
                               name="edit_amount_per_payrolled_worker" class="form-input"
                               :class="[classes, ($store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('admin')) ? '' : 'disabled']"
                               :readonly="(!$store.state.auth.me.roles.includes('manager') && !$store.state.auth.me.roles.includes('admin'))">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Rebate start date -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Rebate start date" tag="div">
                      <label class="form-label" for="edit_referral_start_date">Rebate start date</label>
                      <datepicker v-model="referral_rebate.rebate.referral_start_date" id="edit_referral_start_date" name="edit_referral_start_date" :format="dateFormat"
                                  :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_rebate_start_date"
                                  :input-class="['date-input', classes, ($store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('admin')) ? '' :
                                           'disabled']"
                                  :disabled="(!$store.state.auth.me.roles.includes('manager') && !$store.state.auth.me.roles.includes('admin'))" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                  <!-- Rebate end date -->
                  <div class="col-xl-4 form-group">
                    <ValidationProvider rules="" v-slot="{errors, classes}" name="Rebate end date" tag="div">
                      <label class="form-label" for="edit_referral_end_date">Rebate end date</label>
                      <datepicker v-model="referral_rebate.rebate.referral_end_date" id="edit_referral_end_date" name="edit_referral_end_date"
                                  :format="dateFormat" :clear-button="true"
                                  clear-button-icon="far fa-calendar-times" @input="select_rebate_end_date"
                                  :input-class="['date-input', classes, ($store.state.auth.me.roles.includes('manager') || $store.state.auth.me.roles.includes('admin')) ? '' : 'disabled']"
                                  :disabled="(!$store.state.auth.me.roles.includes('manager') && !$store.state.auth.me.roles.includes('admin'))" :use-utc="true">
                      </datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="col-xl-6">
              <button class="btn orcaBtn grey_bg w-100" @click.prevent="cancel_edit_pre_agreement">Cancel Edit Pre Agreement</button>
            </div>
            <div class="col-xl-6">
              <button type="submit" class="btn orcaBtn w-100" :disabled="saving">
                <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
                <span v-else>Save Pre Agreement - return to Record</span>
              </button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';

// JS arrays
import daysOfWeek from "resources/js/assets/crm_options/days_of_week";
import hoursOfDay from "resources/js/assets/crm_options/hours_of_day";

export default {
  name: "edit_pre_agreement",
  props: ['company', 'd_payment_process_info', 'd_referral_rebate', 'd_pre_agreement'],
  components: {
    Multiselect,
    Datepicker,
    BootstrapToggle
  },
  data() {
    return {
      saving: false,
      pe_ins: process.env.MIX_PE_INS,
      ms_opts: {
        // company
        utr_status: this.$store.state.crm_options.utr_status,
        // pre agreement
        payroll_company_margin_type: this.$store.state.crm_options.fee_type,
        genius_trading_company: this.$store.state.crm_options.payroll_trading_company,
        // accounts info
        fee_type: this.$store.state.crm_options.fee_type,
        pay_cycle: this.$store.state.crm_options.pay_cycle,
        pay_week_start_day: daysOfWeek,
        pay_period_day: daysOfWeek,
        pay_instruction_day: daysOfWeek,
        pay_client_payment_day: daysOfWeek,
        pay_worker_payment_day: daysOfWeek,
        pay_worker_payment_time: hoursOfDay,
        pay_worker_text_day: daysOfWeek,
        v3_partnership_terms: this.$store.state.crm_options.payment_term,
        v3_partnership_margin_type: this.$store.state.crm_options.fee_type,
        gm_solution: this.$store.state.crm_options.payroll_client_solution,
        vat_perc_worked_to: this.$store.state.crm_options.vat_percentage
      },

      company_profile: {
        company_id: this.company.id,
        incorporation_date: this.company.rel_profile.incorporation_date,
        vat_number: this.company.rel_profile.vat_number,
        utr_number: this.company.rel_profile.utr_number,
        utr_status: this.company.rel_profile.utr_status,

        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },

      disable_min_vat: false,

      payment_process_info: {},
      pre_agreement: {},
      referral_rebate: {
        rebate: {}
      }
    }
  },
  beforeMount() {
    if (this.company.rel_profile.utr_status !== null) {
      this.company_profile.utr_status = this.ms_opts.utr_status.find(f => f.value === this.company.rel_profile.utr_status)
    }

    if (this.notEmptyObject(this.d_pre_agreement)) {
      this.pre_agreement = this.d_pre_agreement;
      this.pre_agreement['log_by_type'] = 'App\\Models\\Users\\User';
      this.pre_agreement['log_by_id'] = this.$store.state.auth.me.id;

      if (this.d_pre_agreement.payroll_company_margin_type !== null) {
        this.pre_agreement.payroll_company_margin_type = this.ms_opts.fee_type.find(f => f.value === this.d_pre_agreement.payroll_company_margin_type)
      }
    }
    if (this.notEmptyObject(this.d_payment_process_info)) {
      this.payment_process_info = this.d_payment_process_info;
      this.payment_process_info['log_by_type'] = 'App\\Models\\Users\\User';
      this.payment_process_info['log_by_id'] = this.$store.state.auth.me.id;

      if (this.d_payment_process_info.payroll_solution_id !== null) {
        this.payment_process_info.payroll_solution = this.ms_opts.gm_solution.find(p => p.id === this.d_payment_process_info.payroll_solution_id);
      }
      if (this.d_payment_process_info.pay_cycle_id !== null) {
        this.payment_process_info.pay_cycle = this.ms_opts.pay_cycle.find(p => p.id === this.d_payment_process_info.pay_cycle_id);
      }
      if (this.d_payment_process_info.fee_margin_type !== null) {
        this.payment_process_info.fee_margin_type = this.ms_opts.fee_type.find(p => p.value === this.d_payment_process_info.fee_margin_type);
      }
      if (this.d_payment_process_info.min_vat_percentage_worked_to !== null) {
        this.payment_process_info.min_vat_percentage_worked_to = this.ms_opts.vat_perc_worked_to.find(p => p.value === this.d_payment_process_info.min_vat_percentage_worked_to);
      }
      if (this.d_payment_process_info.recruitment_partnership_fee_type !== null) {
        this.payment_process_info.recruitment_partnership_fee_type = this.ms_opts.fee_type.find(p => p.value === this.d_payment_process_info.recruitment_partnership_fee_type);
      }
    }
    if (this.notEmptyObject(this.d_referral_rebate) && this.notEmptyObject(this.d_referral_rebate.rebate)) {
      this.referral_rebate = this.d_referral_rebate;
      this.referral_rebate.rebate['log_by_type'] = 'App\\Models\\Users\\User';
      this.referral_rebate.rebate['log_by_id'] = this.$store.state.auth.me.id;
    }
    else {
      this.referral_rebate = {
        rebate: {
          company_id: this.company.id,
          referred_company_id: this.company.id,
          amount_per_payrolled_worker: '',
          referral_start_date: null,
          referral_end_date: null,

          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        },
      }
    }
  },
  methods: {
    /* Date Format for dateicker */
    dateFormat(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY");
    },
    // Select actions on datepicker/multiselect
    select_incorporation_date(incorporation_date) {
      if (incorporation_date !== null) {
        this.company_profile.incorporation_date = this.$moment(incorporation_date).utc().format('YYYY-MM-DD');
      }
    },
    select_off_payroll_last_review_date_date(review_date) {
      if (review_date !== null) {
        this.pre_agreement.off_payroll_last_review_date = this.$moment(review_date).utc().format('YYYY-MM-DD');
      }
    },
    select_rebate_start_date(rebate_start_date) {
      if (rebate_start_date !== null) {
        this.referral_rebate.rebate.referral_start_date = this.$moment(rebate_start_date).utc().format('YYYY-MM-DD');
      }
    },
    select_rebate_end_date(rebate_end_date) {
      if (rebate_end_date !== null) {
        this.referral_rebate.rebate.referral_end_date = this.$moment(rebate_end_date).utc().format('YYYY-MM-DD');
      }
    },

    cancel_edit_pre_agreement() {
      if (this.pre_agreement.payroll_company_margin_type !== null) {
        this.pre_agreement.payroll_company_margin_type = this.pre_agreement.payroll_company_margin_type.value;
      }
      if (this.payment_process_info.fee_margin_type !== null) {
        this.payment_process_info.fee_margin_type = this.payment_process_info.fee_margin_type.value;
      }
      if (this.payment_process_info.min_vat_percentage_worked_to !== null) {
        this.payment_process_info.min_vat_percentage_worked_to = this.payment_process_info.min_vat_percentage_worked_to.value;
      }
      if (this.payment_process_info.recruitment_partnership_fee_type !== null) {
        this.payment_process_info.recruitment_partnership_fee_type = this.payment_process_info.recruitment_partnership_fee_type.value;
      }

      this.$parent.edit_pre_agreement = false;
    },
    edit_pre_agreement_submit() {
      this.$refs.editPreAgreementForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.editPreAgreementForm);
        }
        else {
          this.saving = true;

          if (this.company_profile.utr_status !== null) {
            this.company_profile.utr_status = this.company_profile.utr_status.value;
          }

          // console.log(this.company.rel_profile.id)
          // console.log(this.company_profile)
          axios.patch(this.crmApiPath + 'company/profile/' + this.company.rel_profile.id, this.company_profile).then(() => {

            let pre_agreement_promises = [];

            pre_agreement_promises.push(new Promise(resolve => {
              if (this.payment_process_info.payroll_solution !== null) {
                this.payment_process_info.payroll_solution_id = this.payment_process_info.payroll_solution.id
              }
              if (this.payment_process_info.pay_cycle !== null) {
                this.payment_process_info.pay_cycle_id = this.payment_process_info.pay_cycle.id
              }
              if (this.payment_process_info.fee_margin_type !== null) {
                this.payment_process_info.fee_margin_type = this.payment_process_info.fee_margin_type.value;
              }
              if (this.payment_process_info.min_vat_percentage_worked_to !== null && this.payment_process_info.min_vat_percentage_worked_to !== '') {
                this.payment_process_info.min_vat_percentage_worked_to = this.payment_process_info.min_vat_percentage_worked_to.value;
              }
              if (this.payment_process_info.recruitment_partnership_fee_type !== null && this.payment_process_info.recruitment_partnership_fee_type !== '') {
                this.payment_process_info.recruitment_partnership_fee_type = this.payment_process_info.recruitment_partnership_fee_type.value;
              }

              axios.patch(this.crmApiPath + 'company/payment_process_info/' + this.d_payment_process_info.id, this.payment_process_info).then(() => resolve());
            }));

            pre_agreement_promises.push(new Promise(resolve => {
              if (this.pre_agreement.payroll_company_margin_type !== null && this.pre_agreement.payroll_company_margin_type !== '') {
                this.pre_agreement.payroll_company_margin_type = this.pre_agreement.payroll_company_margin_type.value;
              }

              axios.patch(this.crmApiPath + 'company/pre_agreement/' + this.pre_agreement.id, this.pre_agreement).then(() => resolve());
            }));

            Promise.all(pre_agreement_promises).then(() => {
              if (this.referral_rebate.rebate.amount_per_payrolled_worker !== null && this.referral_rebate.rebate.referral_start_date !== null) {
                if (this.notEmptyObject(this.d_referral_rebate) && this.notEmptyObject(this.d_referral_rebate.rebate)) {
                  axios.patch(this.crmApiPath + 'company/referral_rebate/' + this.d_referral_rebate.rebate.id, this.referral_rebate.rebate).then(() => {
                    this.$bus.$emit('company::reload', {action: true});
                    this.$bus.$emit('company_referral::reload', {action: true});
                    this.$bus.$emit('company_pre_agreement::reload', {action: true});
                    this.$bus.$emit('company_payment_process::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    this.$parent.edit_pre_agreement = false;
                  });
                }
                else {
                  axios.post(this.crmApiPath + 'company/referral_rebate', this.referral_rebate.rebate).then(() => {

                    this.$bus.$emit('company::reload', {action: true});
                    this.$bus.$emit('company_referral::reload', {action: true});
                    this.$bus.$emit('company_pre_agreement::reload', {action: true});
                    this.$bus.$emit('company_payment_process::reload', {action: true});
                    this.$bus.$emit('logs::reload', {action: true});
                    this.$parent.edit_pre_agreement = false;
                  });
                }

              }
              else {
                this.$bus.$emit('company::reload', {action: true});
                this.$bus.$emit('company_pre_agreement::reload', {action: true});
                this.$bus.$emit('company_payment_process::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
                this.$parent.edit_pre_agreement = false;
              }
            });
          });

        }
      });
    }
  },
  watch: {
    'pre_agreement.use_a_payroll_company'(val) {
      if (!val) {
        this.pre_agreement.current_payroll_company_tos_stipulate = '';
      }
    },
    'pre_agreement.utilise_ltd_pscs'(val) {
      if (!val) {
        this.pre_agreement.no_limited_companies_engaged = '';
        this.pre_agreement.no_pscs_engaged = '';
        this.pre_agreement.process_cw_scs = '';
      }
    },
    'pre_agreement.use_recruitment_agencies'(val) {
      if (!val) {
        this.pre_agreement.recruitment_approx_weekly_no = '';
        this.pre_agreement.recruitment_payroll_process = '';
      }
    },
    'pre_agreement.use_accountants'(val) {
      if (!val) {
        this.pre_agreement.accountant_company = '';
        this.pre_agreement.accountant_contact = '';
        this.pre_agreement.accountant_contact_number = '';
        this.pre_agreement.accountant_company_contractor_hr = false;
      }
    },
    'pre_agreement.outsource_employment_law_hr'(val) {
      if (!val) {
        this.pre_agreement.outsourced_employment_law_hr_spend = '';
      }
    },
    'pre_agreement.ir35_advice_received'(val) {
      if (!val) {
        this.pre_agreement.ir35_advice_received_from = '';
        this.pre_agreement.ir35_strategy = '';
        this.pre_agreement.intermediaries_strategy = '';
        this.pre_agreement.r2w_strategy = '';
      }
    },
    'pre_agreement.signed_up_to_citb'(val) {
      if (!val) {
        this.pre_agreement.citb_charge_onto_contractors = false;
      }
    },
    'payment_process_info.fee_margin_agreed'(val) {
      if (!val) {
        this.payment_process_info.fee_margin_type = null;
        this.payment_process_info.fee_margin_amount = '';
        this.payment_process_info.payroll_pe_insurance = false;
      }
    },
    'payment_process_info.payroll_require_payment_terms'(val) {
      if (!val) {
        this.payment_process_info.payroll_payment_terms_length = '';
        this.payment_process_info.recruitment_partnership_fee_value = ''
      }
    },
    'payment_process_info.recruitment_partnership'(val) {
      if (!val) {
        this.payment_process_info.recruitment_partnership_fee_type = null;
        this.payment_process_info.recruitment_partnership_fee_value = '';
      }
    },
    'payment_process_info.payroll_solution'(val) {
      if (val !== null && val.value === 'Standard Payroll') {
        this.ms_opts.vat_perc_worked_to = [{id: 14, value: '20%'}];
        this.payment_process_info.min_vat_percentage_worked_to = {id: 14, value: '20%'}
        this.disable_min_vat = true;
      }
      else {
        this.ms_opts.vat_perc_worked_to = this.$store.state.crm_options.vat_percentage
        this.disable_min_vat = false;
      }
    }
  }
}
</script>
